export default [
  {
    path: '/departmentPosition/importBatch',
    component: () => import('@/views/hrManage/departmentPosition/importBatch'),
    name: 'DepartmentPositionImportBatch',
    meta: { title: '批量导入', icon: 'a-up', noCache: false },
    hidden: true
  },
  {
    path: '/specialDeduction/importBatch',
    component: () => import('@/views/organization/specialDeduction/importBatch'),
    name: 'SpecialDeductionImportBatch',
    meta: { title: '批量导入', icon: 'a-up', noCache: false },
    hidden: true
  },
]
